//#region ENUM AnimationLoadingGNameEnum

export enum AnimationLoadingGNameEnum {
  DASH_RUNNER = 'dash-runner',
  DASH_RUNNER_NEON = 'dash-runner-neon',
  DASH_RUNNER_REVERSE = 'dash-runner-reverse',
  DRAW_ONCE = 'animation-draw-once',
  DRAW_ONCE_NEON = 'animation-draw-once-neon',
  DRAW_ONCE_NEON_FLASH = 'animation-draw-once-neon-flash',
  DRAW_REVERSE_ONCE = 'animation-draw-reverse-once',
}

//#endregion

//#region TYPE AnimationLoadingGNameEnumType
/**
 * ### AnimationLoadingGNameEnumType
 * Union type of all keys in `AnimationLoadingGNameEnum`.
 *
 * @type AnimationLoadingGNameEnumType
 * @example
 * // Possible values: 'DRAW'
 */
export type AnimationLoadingGNameEnumType = keyof typeof AnimationLoadingGNameEnum;
//#endregion
